export const PAYMENT_TYPE = {
  cash: 'cash',
  card: 'card',
  reader: 'reader',
  readerless: 'readerless',
  giftCard: 'gift_card',
  payfac: 'squire',
};

export const PAYMENT_PROCESSOR_READER = {
  stripe: 'stripe',
  payworks: 'payworks',
};

export const OPEN_TIP_SCREEN = 'OPEN_TIP_SCREEN';
export const OPEN_URL = 'OPEN_URL';
export const CANCEL_PAYMENT = 'CANCEL_PAYMENT';
export const IOS_BRIDGE_PAYMENT_SUCCESS = 'IOS_BRIDGE_PAYMENT_SUCCESS';
export const WEBREADER_PAYMENT_SUCCESS = 'WEBREADER_PAYMENT_SUCCESS';
export const PAYMENT_FAILED = 'PAYMENT_FAILED';
export const CLOSE_TIP_SCREEN = 'CLOSE_TIP_SCREEN';
export const FETCH_PAYMENT_CARD = 'FETCH_PAYMENT_CARD';
export const CREATE_PAYMENT_CARD = 'CREATE_PAYMENT_CARD';
export const RESET_PAYMENT_CARD = 'RESET_PAYMENT_CARD';
export const OPEN_CANCEL_PAYMENT_MODAL = 'OPEN_CANCEL_PAYMENT_MODAL';
export const CLOSE_CANCEL_PAYMENT_MODAL = 'CLOSE_CANCEL_PAYMENT_MODAL';
export const CLEAR_PAYING_OBJECT = 'CLEAR_PAYING_OBJECT';
export const SET_PAYING_OBJECT = 'SET_PAYING_OBJECT';
